import Live3Kh from "../../components/live3/kh/Live3Kh";
import { useSocket } from "../../helpers/socket";

const Live3KHPage = () => {
    const { socket } = useSocket({ platform: "kh_website" });
    return <Live3Kh socket={socket} />
}

export default Live3KHPage;